import {Columns} from 'compob2b-table';
import {translations} from '../../../../environments/translations.ru';


export const DAM_EXTERNAL_UPLOAD_FORM: Columns[] = [
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    formly: true,
    type: 'input',
    required: true,
  },
  {
    key: 'startDate',
    title: translations.startDate,
    placeholder: translations.startDate,
    formly: true,
    type: 'date',
  },
  {
    key: 'endDate',
    title: translations.endDate,
    placeholder: translations.endDate,
    formly: true,
    type: 'date',
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    formly: true,
    defaultValue: true,
    type: 'checkbox',
    required: true
  }
];
